<template>
  <div>
    <CRow>
      <CCol xs="12" sm="4" md="3" lg="3" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" locale="vi" v-model="dateRange"
                      :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }" is-range
                      class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                     class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300" readonly/>
            </template>
          </DatePicker>
        </div>
      </CCol>
      <!-- <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
        <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
        </BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
        <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
      </CCol> -->
      <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="$hasAuthor('ROLE_ADMIN')">
        <BaseSelect :options="deviceInput.options" :data="deviceInput.data" ref="deviceInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2">
        <BaseInput :options="titleInput.options" :data="titleInput.data"/>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right; margin-left: 5px" color="primary" v-c-tooltip.hover="'Tải lại'"
                     class="btn-action-primary" @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
            <CButton style="float: right;" color="primary" v-c-tooltip.hover="'Thêm mới'" class="btn-action-primary"
                     @click="$router.push('/schedule-management/schedule-add.html')">
              <i class="fa fa-plus"></i>&nbsp;Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
                   ref="mainTable">
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #createDate="{ item }">
            <td>
              <div style="font-weight: bold;" v-c-tooltip.hover="{ content: 'Người tạo lịch', placement: 'right' }">
                {{ item.createUserName }}
              </div>
              <div v-c-tooltip.hover="{ content: 'Thời gian tạo lịch', placement: 'right' }">
                {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
              </div>
            </td>
          </template>
          <template #fromDate="{ item }">
            <td>
              <span v-if="item.mode == 3">
                {{ $helper.formatDate(item.fromDate) }}
              </span>
              <span v-else>
                {{ $helper.formatDateDDMMYYYY(item.fromDate) }}
              </span>
            </td>
          </template>
          <template #toDate="{ item }">
            <td>
              <span v-if="item.mode == 3">
                {{ $helper.formatDate(item.toDate) }}
              </span>
              <span v-else>
                {{ $helper.formatDateDDMMYYYY(item.toDate) }}
              </span>
            </td>
          </template>
          <template #fileTitle="{ item }">
            <td style="font-weight: bold; cursor: pointer">
              <template v-if="item.mode != 3">
                <span v-if="item.fileTitle != null && item.fileTitle != ''"
                      v-c-tooltip.hover="{ content: 'Ấn để nghe' }" @click="previewFile(item.fileTitle, item.fileUrl)">
                  {{ item.fileTitle }}
                </span>
                <span v-else-if="item.channelDigitalName != null && item.channelDigitalName != ''"
                      v-c-tooltip.hover="{ content: 'Ấn để nghe' }"
                      @click="previewFile(item.channelDigitalName, item.channelDigitalUrl, true)">
                  {{ item.channelDigitalName }}
                </span>
              </template>
              <template v-else>
                <span v-c-tooltip.hover="{ content: 'Ấn để nghe' }" @click="previewFile(item.title, item.url)">{{
                    item.title
                  }}</span>
              </template>
            </td>
          </template>
          <template #devices="{ item, index }">
            <td>
              <span class="badge badge-light mr-2" v-for="(each) in viewDevice(item)">
                {{ each }}
              </span>
              <span class="badge badge-light"
                    v-if="$helper.convertStringToArray(item.devices, ';\n').length > maxDisplayDeviceTable"
                    v-c-tooltip.hover="{ content: `<b>${item.devices}</b>`, placement: 'right' }">...</span>
            </td>
          </template>
          <template #mode="{ item }">
            <td>
              <span class="badge badge-light" v-if="item.mode == 0">Khung giờ cố định</span>
              <span class="badge badge-light" style="font-weight:bold" v-else-if="item.mode == 1">Theo lịch thiết lập
                <br>
                ({{
                  item.modeSchedule == 0 ? 'Ngày trong tuần' : 'Ngày trong tháng'
                }})</span>
              <span class="badge badge-danger" v-else-if="item.mode == 2">Khẩn cấp</span>
              <span class="badge badge-primary" v-else-if="item.mode == 3">Phát trực tiếp</span>
            </td>
          </template>
          <template #active="{ item }">
            <td>
              <span v-if="item.active == 1" class="dot-custom dot-success">
                Hoạt động
                <BaseSwitch class="mx-1" color="success" checked variant="3d" v-c-tooltip.hover="'Hủy'"
                            v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_active', item.id, item.active, item.fromDate, item.toDate)"/>
              </span>
              <span v-else class="dot-custom dot-danger">
                Đã hủy
                <BaseSwitch class="mx-1" color="danger" variant="3d" v-c-tooltip.hover="'Kích hoạt'" v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_active', item.id, item.active, item.fromDate, item.toDate)"/>
              </span>
            </td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <!-- <a v-if="item.mode != 3"
                class="a btn-sm btn btn-outline-info"  :href="`/schedule-management/${item.id}/managed-shedule-detail.html`"
                  v-c-tooltip.hover="'Xem chi tiết'">
                  <i class="fa fa-eye"></i>
                </a> -->
                <CButton v-if="item.mode != 3" color="info" variant="outline" v-c-tooltip.hover="'Xem chi tiết'" square
                         size="sm" @click="viewDetail($event, item)">
                  <i class="fa fa-eye"></i>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <CModal title="Lịch phát đã tồn tại" :show.sync="exist.isShowModelExist" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          Đã tồn tại lịch phát ngày <span style="font-weight:bold">{{ exist.playDate }}</span>
          khung giờ <span style="font-weight:bold">{{ exist.startTime + ' - ' + exist.endTime }}</span>
          với các thiết bị:
          <span v-for="i of exist.devices">
            <br/>
            {{ '- ' + i }}
          </span>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="exist.isShowModelExist = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="$router.push(`${exist.id}/managed-shedule-detail.html`)">
          <i class="fa fa-eye"></i> Xem lịch
          đã tồn tại
        </button>
      </template>
    </CModal>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
    <BaseFormPreview v-if="previewModel.isShowModal"
                     :title="previewModel.title"
                     :url="previewModel.url"
                     @close-modal="previewModel.isShowModal = false"></BaseFormPreview>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";
import {USER_NAME} from '../../constant';
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseModal from "@/views/base/BaseModal";
import BaseInput from "@/views/base/BaseInput";
import BaseFormPreview from "@/views/base/BaseFormPreview";

export default {
  name: "ScheduleList",
  components: {
    BaseFormPreview,
    BaseInput,
    BaseModal,
    BaseSelect,
    BaseFormLoading,
    BaseTable,
    DatePicker,
    ModalConfirm,
    BaseSwitch
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    let actionTypeMapping = new Map();

    actionTypeMapping.set("update_active", {
      url: "/schedule/update-active",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.active == true ? "hủy toàn bộ lịch" : "kích hoạt toàn bộ lịch", 'từ ngày'
            , that.$helper.formatDateDDMMYYYY(that.actionData.model.fromDate) + ' đến ngày '
            + that.$helper.formatDateDDMMYYYY(that.actionData.model.toDate))
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.id,
          userName: localStorage.getItem(USER_NAME),
          active: that.actionData.model.active == true ? 0 : 1
        };
      },
      successCallback: function (response) {
        if (response.data && response.data.id) {
          that.exist.id = response.data.id;
          that.exist.msg = response.data.msg;
          that.exist.startTime = response.data.startTime;
          that.exist.endTime = response.data.endTime;
          that.exist.playDate = response.data.playDate;
          that.exist.devices = response.data.devices;
          that.exist.isShowModelExist = true;
        } else {
          that.showSuccessMsg({message: that.actionData.model.active == true ? "Hủy lịch thành công" : "Kích hoạt lịch thành công"});
          that.loadDataMainTable();
        }
      },
      errorCallback: function (error) {
        console.log(error)
        that.$helper.handleError(that.$router, error);
      },
    });

    return {
      loading: {value: false},
      loadingPreview: {value: false},
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      exist: {
        id: "",
        msg: "",
        playDate: "",
        startTime: "",
        endTime: "",
        devices: [],
        isShowModelExist: false
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          id: null,
          active: null,
          fromDate: null,
          toDate: null
        }
      },
      previewModel: {
        isShowModal: false,
        title: '',
        url: ''
      },
      dateRange: {
        start: this.$helper.subtractNowDate(3),
        end: this.$helper.plusDateTime(1, 'd')._d
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: true,
          disabled: true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      deviceInput: {
        options: {
          filter: true,
          label: "Thiết bị",
          selectAllText: "Tất cả thiết bị",
          'keyField': 'value',
          'valueField': 'text'
        },
        data: {
          name: "deviceId",
          model: '',
          items: [],
          source: {
            url: '/devices/find-all',
            dataSubmit: function () {
              return {}
            },
            isJsonContentType: false,
            response: function (dataResponse) {
              that.deviceInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      titleInput: {
        options: {
          placeholder: "Nội dung phát",
          label: 'Nội dung phát'
        },
        data: {
          name: "title",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT", sorter: false, filter: false},
            {key: "createDate", label: "Thông tin lịch"},
            {key: "description", label: "Mô tả"},
            {key: "fileTitle", label: "Nội dung phát"},
            {key: "fromDate", label: "Thời điểm bắt đầu"},
            {key: "toDate", label: "Thời điểm kết thúc"},
            {key: "devices", label: "Thiết bị phát"},
            {key: "mode", label: "Kiểu lịch"},
            {key: "locationName", label: "Địa bàn tạo"},
            // {key: "active", label: "Trạng thái", _style: "width:10%"},
            {key: "action", label: "Thao tác", sorter: false, filter: false}
          ],
          slots: [
            "index", "createDate", "fileTitle", "fromDate", "toDate", "devices", "mode",
            // "active",
            "action"
          ],
          lazyLoad: false,
          sorter: true,
          columnFilter: false,
          pageSize: 15,
          itemsPerPageSelect: {label: ' ', values: [15, 20, 50], external: true},
          tableFilter: {label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true},
        },
        dataSource: {
          url: "/schedule/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
            params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
            params.locationCode = that.locationCode.data.model;
            params.title = that.titleInput.data.model;
            params.deviceId = that.deviceInput.data.model;
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
      hlsPreview: '',
      maxDisplayDeviceTable: 5,
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    setupSelectOneAction: function (actionTypeKey, id, active, fromDate, toDate) {
      let actionData = this.actionData.model;
      actionData.id = id || null;
      actionData.active = active || null;
      actionData.fromDate = fromDate || null;
      actionData.toDate = toDate || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    viewDetail(event, item) {
      if (event.ctrlKey) {
        const routeData = this.$router.resolve(`${item.id}/managed-shedule-detail.html`);
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push(`${item.id}/managed-shedule-detail.html`)
      }
    },
    previewFile(title, url) {
      this.previewModel.title = title;
      this.previewModel.url = url;
      this.previewModel.isShowModal = true;
    },
    viewDevice(item) {
      if (!item.devices) {
        return [];
      }
      var _devices = this.$helper.convertStringToArray(item.devices, ';\n');
      if (_devices.length <= this.maxDisplayDeviceTable) {
        return _devices;
      }
      return _devices.slice(0, this.maxDisplayDeviceTable);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date().setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
